import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@/components/ui/inputs/input';
import { InputSelect } from '@/components/ui/inputs/input-select';
import { InputDatepicker } from '@/components/ui/inputs/input-datepicker';
import { useForm, Controller } from 'react-hook-form';
import { getCustomerService } from '@/services/CustomerServices';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';

const DataTableFilter = ({ onChangeFilter }) => {
    const selectRef = useRef(null);
    const dispatch = useDispatch();
    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm({
        defaultValues: {
            order_serial_no: '',
            user_id: '',
            order_datetime: '',
            status: '',
        },
        mode: 'onSubmit',
    });
    const [isLoading, setIsLoading] = useState(false);
    const [customersOptionList, setCustomersOptionList] = useState([]);
    const statusOptionList = [
        { value: 1, label: 'Pending' },
        { value: 2, label: 'Placed' },
        { value: 3, label: 'Accept' },
        { value: 4, label: 'Processing' },
        { value: 5, label: 'Out for delivery' },
        { value: 6, label: 'Delivered' },
        { value: 7, label: 'Canceled' },
        { value: 8, label: 'Rejected' },
        { value: 9, label: 'Returned' },
    ];
    useEffect(() => {
        getCustomers();
    }, []);

    const convertUndefinedToBlank = (obj) => {
        return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, value === undefined ? '' : value]));
    };

    const clearSelection = () => {
        if (selectRef.current) {
            selectRef.current.clearValue();
        }
    };

    const getCustomers = () => {
        setIsLoading(true);
        dispatch(
            getCustomerService({
                search: '',
                page: 1,
                limit: 100,
                extra_filter: {},
            })
        )
            .then((res) => {
                var customersDataArr = res?.data?.data?.data;
                var customersOptionArray = [];
                customersDataArr.forEach((element) => {
                    customersOptionArray.push({
                        value: element?._id,
                        label: element?.name,
                    });
                });
                setCustomersOptionList(customersOptionArray);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const formReset = async () => {
        try {
            var formData = getValues();
            for (const key in formData) {
                await setValue(key, '');
            }
            await reset();
            await clearSelection();
            await onChangeFilter('extra_filter', {});
        } catch (error) {
            console.error('Error in onReset:', error);
        }
    };

    const onSubmit = async (data) => {
        try {
            console.log(data);
            const filterData = await convertUndefinedToBlank(data);
            await onChangeFilter('extra_filter', filterData);
        } catch (error) {
            console.error('Error in onSubmit:', error);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-4 sm:p-5 mb-5">
            <div className="row">
                <div className="col-12 sm:col-6 md:col-4 xl:col-3">
                    <Controller
                        control={control}
                        name="order_serial_no"
                        render={({ field }) => (
                            <Input {...field} size="sm" labelText={'Order ID'} type="text" id="order_serial_no" className="db-field-control" labelStyleClassName={'db-field-title after:hidden'} />
                        )}
                    />
                </div>
                <div className="col-12 sm:col-6 md:col-4 xl:col-3">
                    <Controller
                        control={control}
                        name="status"
                        render={({ field }) => (
                            <InputSelect
                                {...field}
                                ref={selectRef}
                                id={'status'}
                                size="sm"
                                labelStyleClassName={'db-field-title after:hidden'}
                                labelText={'Status'}
                                value={statusOptionList.find((data) => data.value === getValues('status')) || null}
                                onChange={(e) => setValue('status', e)}
                                options={statusOptionList}
                            />
                        )}
                    />
                </div>
                <div className="col-12 sm:col-6 md:col-4 xl:col-3">
                    <Controller
                        control={control}
                        name="user_id"
                        render={({ field }) => (
                            <InputSelect
                                {...field}
                                ref={selectRef}
                                id={'user_id'}
                                size="sm"
                                labelStyleClassName={'db-field-title after:hidden'}
                                labelText={'Customer'}
                                value={customersOptionList.find((data) => data.value === getValues('user_id')) || null}
                                onChange={(e) => setValue('user_id', e)}
                                options={customersOptionList}
                            />
                        )}
                    />
                </div>
                <div className="col-12 sm:col-6 md:col-4 xl:col-3">
                    <Controller
                        control={control}
                        name="order_datetime"
                        render={({ field }) => (
                            <InputDatepicker
                                {...field}
                                onChange={(date) => setValue('order_datetime', date)}
                                selected={getValues('order_datetime')}
                                size="sm"
                                labelText={'Date'}
                                type="date"
                                id="order_datetime"
                                className="db-field-control"
                                labelStyleClassName={'db-field-title after:hidden'}
                            />
                        )}
                    />
                </div>

                <div className="col-12">
                    <div className="flex flex-wrap gap-3 mt-4">
                        <button type="submit" className="db-btn py-2 text-white bg-primary">
                            <i className="lab lab-search-line lab-font-size-16"></i>
                            <span>Search</span>
                        </button>
                        <button type="button" onClick={formReset} className="db-btn py-2 text-white bg-gray-600">
                            <i className="lab lab-cross-line-2 lab-font-size-22"></i>
                            <span>Clear</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default DataTableFilter;
